module.exports = __webpack_public_path__ + "9a6ba57d2e2f04b1b0ceade846fc61db.svg";